'use client'
const TURNKEY_API_BASE_URL = 'https://api.turnkey.com';
const TURNKEY_API_KEY_EXPIRY_MESSAGE = 'Turnkey error 16: expired api key';
const TURNKEY_API_KEY_NOT_FOUND_MESSAGE = 'Turnkey error 16: could not find public key';
const WEBAUTHN_NOT_SUPPORTED_OR_CANCELLED_ERROR_MESSAGE = 'The operation either timed out or was not allowed';
const WEBAUTHN_NOT_SUPPORTED_OR_DISABLED_ERROR_MESSAGE = 'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.';
const INVALID_PASSKEY_SELECTED_ERROR_MESSAGE = 'Turnkey error 5: webauthn authenticator not found in organization or parent organization';
const USER_CANCELLED_REQUEST_ERROR_MESSAGE = 'The user cancelled the request';
const TURNKEY_SDK_SESSION_KEY_RETRYABLE_ERRORS = [
    TURNKEY_API_KEY_EXPIRY_MESSAGE,
    TURNKEY_API_KEY_NOT_FOUND_MESSAGE,
];
const TURNKEY_SDK_BENIGN_ERRORS = [
    WEBAUTHN_NOT_SUPPORTED_OR_CANCELLED_ERROR_MESSAGE,
    WEBAUTHN_NOT_SUPPORTED_OR_DISABLED_ERROR_MESSAGE,
    INVALID_PASSKEY_SELECTED_ERROR_MESSAGE,
    USER_CANCELLED_REQUEST_ERROR_MESSAGE,
];

export { INVALID_PASSKEY_SELECTED_ERROR_MESSAGE, TURNKEY_API_BASE_URL, TURNKEY_API_KEY_EXPIRY_MESSAGE, TURNKEY_API_KEY_NOT_FOUND_MESSAGE, TURNKEY_SDK_BENIGN_ERRORS, TURNKEY_SDK_SESSION_KEY_RETRYABLE_ERRORS, USER_CANCELLED_REQUEST_ERROR_MESSAGE, WEBAUTHN_NOT_SUPPORTED_OR_CANCELLED_ERROR_MESSAGE, WEBAUTHN_NOT_SUPPORTED_OR_DISABLED_ERROR_MESSAGE };
